import { LocalPlatformAdapter, type PlatformCapabilities } from "./PlatformAdapter";

/**
 * Placeholder for GamePix. Advertises ads/rewarded for UI wiring; methods stay
 * no-ops (inherited) until the external GamePix SDK is bound in a later phase.
 * No SDK dependency is imported.
 */
export class GamePixPlatformAdapter extends LocalPlatformAdapter {
  getCapabilities(): PlatformCapabilities {
    return { ads: true, rewarded: true, banner: false, cloudSave: false, leaderboard: false };
  }
}
